import styled, { css } from 'styled-components';
import { imagePulse } from '@/components/image/imagePulse.styles';
import { imageBlurredFadeIn } from '@/components/image/imageLoadedFadeIn.styles';
import { imageFilter } from '@/components/image/imageFilter.styles';

export const ImageWrapper = styled.div`
  ${({ theme, ...props }) => {
    return css`
      position: relative;
      width: 100%;
      height: 100%;
      overflow: hidden;
      border-radius: ${theme.radius.sm};

      img {
        object-fit: cover;
        user-select: none;

        ${imageBlurredFadeIn};
      }

      ${imageFilter};
      ${imagePulse};
    `;
  }};
`;
